import Login from '../components/Auth/Login/Login';
import CoursesPage from '../pages/courses/page';
import NewCoursePage from '../pages/courses/new/page';
import CourseDetail from '../pages/courses/[id]/page';
import EditCoursePage from '../pages/courses/[id]/edit/page';
import ExamResultsPage from '../pages/courses/exam/[id]/page';
import ScheduleSchedulePage from '../pages/courses/schedule/[id]/page';
import LessonPlanPage from '../pages/lesson-plans/[id]/page';
import LicenseClassesPage from '../pages/lesson-plans/page';
import DecisionsPage from '../pages/decisions/page';
import useLicenseClasses from '../pages/license/page';
import Partners from '../pages/partner/page';
import NewSubjectPage from '../pages/subjects/new/page';
import EditSubjectPage from '../pages/subjects/[id]/edit/page';
import SubjectsPage from '../pages/subjects/page';
import TeachersPage from '../pages/teachers/page';
import NewTeacherPage from '../pages/teachers/new/page';
import EditTeacherPage from '../pages/teachers/[id]/edit/page';
import TrainingPlantPage from '../pages/training-plans/page';
import LicenseClassTrainingPlan from '../pages/training-plans/[id]/page';
import UploadPage from '../pages/upload/page';
import NewVehiclePage from '../pages/vehicles/new/page';
import EditVehiclePage from '../pages/vehicles/[id]/edit/page';
import VehiclesPage from '../pages/vehicles/page';
import SettingsPage from '../pages/settings/page';
import EndSemester from '../pages/courses/end-semester/EndSemester';
import Auditlog from '../pages/audit-log/Auditlog';

export const routes = [
	{
		path: '/auth',
		component: Login,
		exact: true,
	},
	{
		path: '/courses',
		component: CoursesPage,
		exact: true,
	},
	{
		path: '/courses/new',
		component: NewCoursePage,
		exact: true,
	},
	{
		path: '/courses/:courseId',
		component: CourseDetail,
		exact: true,
	},
	{
		path: '/courses/:courseId/edit',
		component: EditCoursePage,
		exact: true,
	},
	{
		path: '/courses/exam/:courseId',
		component: ExamResultsPage,
		exact: true,
	},
	{
		path: '/courses/schedule/:courseId',
		component: ScheduleSchedulePage,
		exact: true,
	},
	{
		path: '/lesson-plans',
		component: LicenseClassesPage,
		exact: true,
	},
	{
		path: '/lesson-plans/:licenseClassId',
		component: LessonPlanPage,
		exact: true,
	},	{
		path: '/license',
		component: useLicenseClasses,
		exact: true,
	},	{
		path: '/partner',
		component: Partners,
		exact: true,
	},
	{
		path: '/subjects',
		component: SubjectsPage,
		exact: true,
	},
	{
		path: '/subjects/new',
		component: NewSubjectPage,
		exact: true,
	},
	{
		path: '/subjects/:id/edit',
		component: EditSubjectPage,
		exact: true,
	},
	{
		path: '/teachers',
		component: TeachersPage,
		exact: true,
	},
	{
		path: '/teachers/new',
		component: NewTeacherPage,
		exact: true,
	},
	{
		path: '/teachers/:id/edit',
		component: EditTeacherPage,
		exact: true,
	},
	{
		path: '/training-plans',
		component: TrainingPlantPage,
		exact: true,
	}, {
		path: '/training-plans/:licenseClassId',
		component: LicenseClassTrainingPlan,
		exact: true,
	},{
		path: '/upload',
		component: UploadPage,
		exact: true,
	},{
		path: '/vehicles',
		component: VehiclesPage,
		exact: true,
	},
	{
		path: '/vehicles/new',
		component: NewVehiclePage,
		exact: true,
	},{
		path: '/vehicles/:id/edit',
		component: EditVehiclePage,
		exact: true,
	},{
		path: '/vehicles/:id',
		component: EditVehiclePage,
		exact: true,
	},{
		path: '/settings',
		component: SettingsPage,
		exact: true,
	},{
		path: '/end-semester',
		component: EndSemester,
		exact: true,
	},{
		path: '/audit-log',
		component: Auditlog,
		exact: true,
	},
	{
		path: '/decisions',
		component: DecisionsPage,
		exact: true,
	},
];